import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as irActions from '../../../redux/actions/irSearch'
import LoadingBar from '../../common/LoadingBar'
import AlertError from '../../common/AlertError'
import UpdateFromPacer from '../../common/UpdateFromPacer'
import FilterTable from '../../common/FilterTable'

import './CaseCreditors.less'

export class CaseCreditors extends Component {

  componentDidMount() {
    if (this.props.purchase_right_away)
      this.purchaseCreditors();
    else
      this.getCreditors();
  }

  getCreditors = () => {
    this.props.dispatch(irActions.getCaseData({
      type: 'creditors',
      case_uuid: this.props.case_uuid,
    }));
  }

  purchaseCreditors = () => {
    this.props.dispatch(irActions.purchaseCaseData({
      type: 'creditors',
      case_uuid: this.props.case_uuid,
    }));
  }

  render() {
    if (!this.props.dataReady) return <LoadingBar/>;

    const alertError = this.props.error ? <AlertError errors={this.props.error}/> : null;

    const creditors = this.props.creditors;

    return (
      <div className="case-creditors">
        {alertError}
        <a href={`/creditors/export-csv/${this.props.case_uuid}`} className="form-submit" style={{ float: "right" }}>Download
          as CSV</a>
        <FilterTable>
          {!!creditors.length && _.get(creditors, '[0][0]') !== 'empty' ? (
            <table className="sticky-enabled tablesorter">
              <thead>
              <tr>
                <th><span>Creditor</span></th>
                <th><span>Code</span></th>
                <th><span>Type</span></th>
              </tr>
              </thead>
              <tbody>{this.getCreditorsTableBody(creditors)}</tbody>
            </table>
          ) : (
            <div
              className="ir-search-status-message messages warning"
            >No creditor found for this case.</div>
          )}
        </FilterTable>
        <UpdateFromPacer
          pacerUpdateHandler={this.purchaseCreditors.bind(null, this.props.case_uuid, 'creditors', true)}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated}/>
      </div>
    );
  }

  NoFound = (
    <span style={{
      marginTop: '24px',
      display: 'table',
      fontWeight: '700'
    }}>No creditor found for this case.</span>
  );

  getCreditorsTableBody = (creditors) => (
    creditors.map((creditor, key) => (
      <tr key={key}>
        <td>
          <div className="ir-search-card">
            <strong>{creditor.name}</strong><br/>
            <span style={{ whiteSpace: 'pre-wrap' }}>{creditor.address}</span>
          </div>
        </td>
        <td>{creditor.creditor_code}</td>
        <td>{'(' + creditor.creditor_role + ')'}</td>
      </tr>
    ))
  );
}

function mapStateToProps(state) {
  const irSearch = state.get('irSearch').toJS();

  return {
    dataReady: irSearch.data_ready,
    creditors: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseCreditors)



/** WEBPACK FOOTER **
 ** ./src/components/case/creditors/CaseCreditors.js
 **/